import usersApi from '@/api/usersApi'

const state = () => ({
  createdUser: {},
  // состояния модальных окон
  modals_active: {
    success: false,
    error: false
  },
  isCreating: false
})

const getters = {
  getCreatedUser: state => state.createdUser,
  userCreatePageModals: state => state.modals_active,
  userCreateIsCreating: state => state.isCreating
}

const mutations = {
  CREATE_USER_START: (state) => {
    state.isCreating = true
  },
  // запись в стейт созданного пользователя
  CREATE_USER_SUCCESS: (state, user) => {
    state.createdUser = user
    state.isCreating = false
  },
  CREATE_USER_FAILURE: (state) => {
    state.isCreating = false
  },
  CREATE_USER_SHOW_SUCCESS: (state) => {
    state.modals_active.success = true
  },
  CREATE_USER_SHOW_ERROR: (state) => {
    state.modals_active.error = true
  },
  CREATE_USER_CLOSE_MODAL: (state) => {
    state.modals_active.success = false
    state.modals_active.error = false
  }
}

const actions = {
  // создание пользователя
  createUser ({ commit }, data) {
    const postData = {
      ...data,
      // бек ждёт массив id, так как там предусмотрено несколько ролей юзера, на фронте выбор нескольких ролей не реализован
      roles: [data.roles.id]
    }
    commit('CREATE_USER_START')

    usersApi.postUser(postData).then(response => {
      // в ответе на созданного пользователя id созданного для него профиля не прилетает, поэтому нужен доп запрос
      if (data.name || data.surname) {
        usersApi.getSingle(response.data.data.id).then(response => {
          const params = {
            id: response.data.data.profile.id,
            updateData: {
              name: data.name,
              surname: data.surname
            }
          }
          usersApi.putProfile(params).then(() => {
            commit('CREATE_USER_SUCCESS', response.data.data)
            this.dispatch('showUserCreateSuccessModal')
          })
        })
      }
    }).catch(error => {
      commit('CREATE_USER_FAILURE')
      commit('CREATE_USER_SHOW_ERROR')
      console.log('ошибка создания нового пользователя', error.response)
    })
  },
  // показ модалки на странице создания пользователя
  showUserCreateSuccessModal ({ commit }) {
    commit('CREATE_USER_SHOW_SUCCESS')
  },
  // показ модалки с ошибкой на странице создания пользователя
  showUserCreateErrorModal ({ commit }) {
    commit('CREATE_USER_SHOW_ERROR')
  },
  // закрытие модалки на странице создания пользователя
  closeUserCreateModal ({ commit }) {
    commit('CREATE_USER_CLOSE_MODAL')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
